/**
 * WordPress dependencies
 */
import { createSlotFill } from '@wordpress/components';

const { Fill, Slot } = createSlotFill( '__unstableAutocompletionItemsSlot' );

export {
	Fill as __unstableAutocompletionItemsFill,
	Slot as __unstableAutocompletionItemsSlot,
};
